import { mapGetters } from 'vuex'
import Vue from 'vue'

import Configuration from '@/agilis/util/Configuration'
import ConfigurationDashboard from '@/agilis/util/ConfigurationDashboard'
import DashboardWrapper from '@/agilis/components/DashboardTabs/DashboardWrapper/DashboardWrapper.vue'
import TabsComponent from '@/agilis/components/Tabs/Tabs.vue'

export default {
  name: 'DashboardTabs',

  components: {
    DashboardWrapper,
    TabsComponent
  },

  data () {
    return {
      dashboardContexts: {}
    }
  },

  created () {
    this.tabs.forEach(tabId => {
      Vue.set(this.dashboardContexts, tabId, this.getDashboardContext(tabId))
    })
  },

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId',
      workspaceId: 'contextStore/workspaceId'
    }),

    dashboards () {
      const authDashboard = Configuration.auth.getDashboardIds(this.applicationId, this.workspaceId)
      const dashboard = Configuration.getApplication(this.applicationId).dashboard
      return Object.keys(dashboard)
        .filter((key) => authDashboard.includes(key))
        .reduce((dash, key) => { return Object.assign(dash, { [key]: dashboard[key] }) }, {})
    },

    tabs () {
      return Object.keys(this.dashboards)
    }
  },

  methods: {
    getDashboardTitle (dashboardId) {
      return this.$t(this.dashboards[dashboardId].name)
    },

    getDashboardContext (dashboardId) {
      return ConfigurationDashboard.getWorkspaceDashboardContext(
        this.applicationId,
        this.workspaceId,
        dashboardId
      )
    },

    setDashboardContext (tabId, dashboardContexts) {
      this.dashboardContexts[tabId] = dashboardContexts
    }
  }
}
